import { z } from 'zod'
import { formatCurrencyToNumber } from '../utils/formatCurrency'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const cashRegisterTransactionSchema = z.object({
  formaPagamento: z.string(),
  valor: z.string().transform((data) => formatCurrencyToNumber(data)),
  descricao: z.string(),
  idCliente: z
    .any()
    .optional()
    .transform((value) => Number((value || 0).toString().replaceAll('.', '').replace('R$ ', '').replace(',', '.'))),
  nomeCliente: z.string().optional(),
  statusHistorico: z.string()
})

export type CashRegisterTransactionForm = z.infer<typeof cashRegisterTransactionSchema>
